if (!customElements.get('custom-card-carousel')) {
  class CustomCardCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.cardCount = Number(this.dataset.cardCount || 0);
      this.resizeTimer = null;
      this.retryCount = 0;
      this.onResize = this.handleResize.bind(this);
      window.addEventListener('resize', this.onResize);
      this.setup();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.resizeTimer);
      this.destroy();
    }

    setup() {
      if (!this.track || this.cardCount < 2) return;

      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
        if (this.retryCount < 40) {
          this.retryCount += 1;
          setTimeout(() => this.setup(), 100);
        }
        return;
      }

      const shouldInitialize = this.cardCount > 4 || (window.innerWidth < 768 && this.cardCount > 1);
      const initialized = this.track.classList.contains('slick-initialized');

      if (shouldInitialize && !initialized) this.initialize();
      if (!shouldInitialize && initialized) this.destroy();
    }

    initialize() {
      const $track = window.jQuery(this.track);
      const loop = this.dataset.loop === 'true';
      const arrows = this.dataset.arrows === 'true';
      const dots = this.dataset.dots === 'true';
      const previousArrow = '<button class="slick-prev" type="button" aria-label="Previous card"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.8 3.8 6.6 10l6.2 6.2-1.4 1.4L3.8 10l7.6-7.6 1.4 1.4Z"/></svg></button>';
      const nextArrow = '<button class="slick-next" type="button" aria-label="Next card"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.2 16.2 6.2-6.2-6.2-6.2 1.4-1.4 7.6 7.6-7.6 7.6-1.4-1.4Z"/></svg></button>';

      $track.on('beforeChange.customCardCarousel', (event, slick, current, next) => {
        const movingNext = next > current || (current === slick.slideCount - 1 && next === 0);
        this.classList.remove('is-moving-next', 'is-moving-prev');
        this.classList.add(movingNext ? 'is-moving-next' : 'is-moving-prev');
      });

      $track.on('afterChange.customCardCarousel', () => {
        setTimeout(() => this.classList.remove('is-moving-next', 'is-moving-prev'), 220);
      });

      $track.slick({
        arrows,
        dots,
        infinite: loop,
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 550,
        swipe: true,
        draggable: true,
        touchThreshold: 8,
        adaptiveHeight: false,
        prevArrow: previousArrow,
        nextArrow,
        rtl: Boolean(window.rtl_slick),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: false
            }
          }
        ]
      });
    }

    destroy() {
      if (!this.track || !window.jQuery || !this.track.classList.contains('slick-initialized')) return;
      const $track = window.jQuery(this.track);
      $track.off('.customCardCarousel');
      $track.slick('unslick');
      this.classList.remove('is-moving-next', 'is-moving-prev');
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.setup(), 180);
    }
  }

  customElements.define('custom-card-carousel', CustomCardCarousel);
}
